<template>
  <div class="post type-post hentry">
    <h2>
      <router-link
        to="/2011/01/kokiais-atvejais-dovanojimo-sutarti-butina-tvirtinti-notariskai/"
        >Kokiais atvejais dovanojimo sutartį būtina tvirtinti notariškai</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">3</span>
    </div>
    <div class="entry">
      <p>
        Dovanojimo sutartys pagal lietuvišką tradiciją ir įstatymus gali būti
        žodinės, rašytinės ir patvirtintos notariškai. Jų sudarymo formą nustato
        LR Civilinio kodekso 6.469 str.
      </p>
      <p>
        Žodžiu gali būti sudaromos tik tokios sutartys, kurių suma (vertė)
        neviršija 5000 Lt. Tačiau, šalims pageidaujant, tokius sandorius
        nedraudžiama įforminti ir raštu arba pasitvirtinti notariškai.
      </p>
      <p>
        Sutartys, kai dovanojamo turto vertė nuo 5000 iki 50000 Lt, turi būti
        rašytinės formos, o šalių pageidavimu gali būti patvirtintos ir
        notariškai. Jeigu nesilaikyta reikalaujamos rašytinės formos, tai kilus
        ginčui, sandoris gali būti pripažintas negaliojančiu.
      </p>
      <p>
        Nekilnojamojo daikto (žemės ir statinių) dovanojimo sutartys, taip pat
        dovanojimo sutartys, kurių suma didesnė kaip 50000 Lt, be išimčių turi
        būti notarinės formos. Šio reikalavimo nesilaikymas sandorį daro
        negaliojančiu.
      </p>
      <p>
        Pravartu žinoti, kad nekilnojamojo arba privalomo registruoti daikto ar
        daiktinės teisės į jį dovanojimo sutartį reikia įregistruoti viešame
        registre, nes prieš trečiuosius asmenis teisines pasekmes turės tik
        įregistruota sutartis.
      </p>
    </div>
  </div>
</template>
